import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import Handler from "../../Helpers/Handler";
import { textCapitalize } from "../../Helpers/Utils";

const StaffPasswordModal = ({ staffId, onClose, onSaved }) => {
    const modalRef = useRef(null);
    const bsModalRef = useRef(null);
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [saving, setSaving] = useState(false);
    // Each field can be shown or hidden on its own. Local to this dialog, so it starts hidden every time it opens.
    const [showNew, setShowNew] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);

    useEffect(() => {
        const el = modalRef.current;
        if (!el || !window.bootstrap) return undefined;
        const instance = window.bootstrap.Modal.getOrCreateInstance(el);
        bsModalRef.current = instance;
        const handleHidden = () => onClose?.();
        el.addEventListener("hidden.bs.modal", handleHidden);
        instance.show();
        return () => {
            el.removeEventListener("hidden.bs.modal", handleHidden);
            instance.hide();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onSubmit = async () => {
        if (password.length < 6) {
            toast.error("Password must be at least 6 characters");
            return;
        }
        if (password !== confirmPassword) {
            toast.error("Passwords do not match");
            return;
        }
        setSaving(true);
        const response = await Handler({ method: "patch", url: `/admin/staff/${staffId}/password`, data: { password } });
        if (response?.success) {
            toast.success(response?.data?.message || "Password reset");
            onSaved?.();
        } else {
            toast.error(textCapitalize(response?.data?.message || "Unable to reset password"));
        }
        setSaving(false);
    };

    return (
        <div className="modal fade" tabIndex="-1" ref={modalRef} aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content border-0 rounded-4">
                    <div className="modal-header">
                        <h5 className="modal-title fw-semibold">Reset Password</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="row g-3">
                            <div className="col-12">
                                <label className="form-label" htmlFor="reset-new-password">New password</label>
                                <div className="input-group">
                                    <input id="reset-new-password" type={showNew ? "text" : "password"} className="form-control" autoComplete="new-password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Min 6 characters" />
                                    <button
                                        type="button"
                                        className="btn btn-outline-secondary"
                                        aria-label={showNew ? "Hide password" : "Show password"}
                                        aria-pressed={showNew}
                                        onClick={() => setShowNew(!showNew)}
                                    >
                                        {showNew ? <FaEyeSlash /> : <FaEye />}
                                    </button>
                                </div>
                            </div>
                            <div className="col-12">
                                <label className="form-label" htmlFor="reset-confirm-password">Confirm password</label>
                                <div className="input-group">
                                    <input id="reset-confirm-password" type={showConfirm ? "text" : "password"} className="form-control" autoComplete="new-password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
                                    <button
                                        type="button"
                                        className="btn btn-outline-secondary"
                                        aria-label={showConfirm ? "Hide password" : "Show password"}
                                        aria-pressed={showConfirm}
                                        onClick={() => setShowConfirm(!showConfirm)}
                                    >
                                        {showConfirm ? <FaEyeSlash /> : <FaEye />}
                                    </button>
                                </div>
                            </div>
                            <div className="col-12 text-muted small">The staff member will be required to change this on their next login.</div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-outline-secondary" data-bs-dismiss="modal">Cancel</button>
                        <button type="button" className="btn btn-primary" onClick={onSubmit} disabled={saving}>
                            {saving ? "Saving..." : "Reset password"}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StaffPasswordModal;
